// extracted by mini-css-extract-plugin
export var discard = "_22-4";
export var muiTooltipTooltip = "_22-6";
export var notificationBar = "_22-3";
export var notificationContainer = "_22-2";
export var saveButtonHoverSlotWrapper = "_22-5";
export var show = "_22-1";
export var spacer = "_22-0";